/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {OfferType} from '../../core/_models'
import {useNavigate} from 'react-router-dom'
import _ from 'lodash'
type Props = {
  offer: OfferType
}

const InfoCell: FC<Props> = ({offer}) => {
  const navigate = useNavigate()
  const viewAllBusinessHandler = () => {
    navigate(`/offers/${offer.id}/${offer.url}`)
  }
  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column'>
        <a
          onClick={viewAllBusinessHandler}
          className='text-gray-800 text-hover-primary mb-1 pointer'
        >
          {offer?.name}
        </a>
      </div>
    </div>
  )
}

export {InfoCell}
